import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-white flex items-center justify-center">
      <div className="max-w-md mx-auto w-full px-6 py-10 text-center">
        <XCircle className="mx-auto text-slate-400" size={56} strokeWidth={1.5} />
        <div className="mt-6 font-manrope text-2xl font-bold text-slate-900">Checkout cancelled</div>
        <p className="mt-2 text-slate-500 text-sm">No worries — you can still use MoneyWise for free. Upgrade whenever you're ready.</p>
        <Link to="/app/profile" data-testid="cancel-back-btn" className="inline-block mt-8 bg-slate-900 text-white rounded-full py-3 px-8 font-semibold hover:bg-slate-800 transition-colors">Back to profile</Link>
      </div>
    </div>
  );
}
